import React, { useRef, useState, useEffect } from "react";
import { Link, Navigate, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Swiper, SwiperSlide } from 'swiper/react';
import axios from "axios";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet";
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import axiosInstance from '../../axiosInstance';

// import required modules
import { Pagination, Navigation,Autoplay } from 'swiper/modules';

import banner1 from '../assets_user/img/fullbanner1.webp';
import banner2 from '../assets_user/img/fullbanner2.webp';
import banner3 from '../assets_user/img/fullbanner3.webp';
import banner4 from '../assets_user/img/fullbanner4.webp';

import grid1 from '../assets_user/img/grid1.webp';
import grid2 from '../assets_user/img/grid2.webp';
import grid3 from '../assets_user/img/grid3.webp';
import grid4 from '../assets_user/img/grid4.webp';
import gridslide1 from '../assets_user/img/gridslide1.webp';
import gridslide2 from '../assets_user/img/gridslide2.webp';
import gridslide3 from '../assets_user/img/gridslide3.webp';
import gridslide4 from '../assets_user/img/gridslide4.webp';
import gridslide5 from '../assets_user/img/gridslide5.webp';
import CreateSlug from "../components/extra/CreateSlug";
import { motion } from "framer-motion";

const HomeNew = () => {

  const [blogs, setBlogs] = useState([]);

    const getUserBlogs = async () => {
    try {
 
      const { data } = await axiosInstance.get(`/all-blogs`);
    
      if (data?.success) {
        setBlogs(data?.blogs);
      }
      setIsLoading(false); // Set loading state to false after fetching data
    } catch (error) {
      console.log(error);
      setIsLoading(false); // Set loading state to false in case of an error
    }
  };

  useEffect(() => {
    getUserBlogs();
  }, []); // Empty dependency array ensures that the effect runs once after the initial render


  const swiperRefLocal = useRef()

  const handleMouseEnter = () => {
      swiperRefLocal?.current?.swiper?.autoplay?.stop()
  };

  const handleMouseLeave = () => {
      swiperRefLocal?.current?.swiper?.autoplay?.start()
  };


  
  const [ratings, setRatings] = useState([]);

  const [layout, setLayout] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [isProducts, setIsProducts] = useState(true);


  const [Products, setProducts] = useState([]);

 


  const getData = async () => {
    try {
   const { data } = await axiosInstance.get(`/home-layout-data`);
      // setLayout(smapledata.homeLayout);
       setLayout(data.homeLayout);
      setIsLoading(false); // Set loading state to false in case of an error
      // console.log('data', data);

    }
    catch (error) {
      console.log(error);
      toast.error("Error fetching Home layout!");
      setIsLoading(false); // Set loading state to false in case of an error
    }
  };

  const SampleRating = {"success":true,"ratings":[]};

  const getRating = async () => {
    try {
      // const { data } = await axiosInstance.get(`/all-rating`);
      // setRatings(data.ratings);
      // console.log('getRating', data)
     setRatings(SampleRating.ratings);
    } catch (error) {
      console.error("Error fetching rating:", error);
    }
  };

  useEffect(() => {
    getData();
    getRating();
  }, []);

 

  const getProducts = async () => {
    try {

      const { data } = await axiosInstance.get("/all-home-products");
      console.log("products", data);
      setProducts(data.products);
      // setProducts(sampleHomePro.products);
      
      setIsProducts(false); // Set loading state to false in case of an error
    } catch (error) {
      console.error("Error fetching products:", error);
      setIsProducts(false); // Set loading state to false in case of an error
    }
  };


  useEffect(() => {
    getProducts();

  }, []);


 
 

  const isMobileScreen = () => {
  return window.innerWidth <= 768; // you can adjust breakpoint (768px = Bootstrap's md)
};
  const [isMobile, setIsMobile] = useState(isMobileScreen());

  useEffect(() => {
    const handleResize = () => setIsMobile(isMobileScreen());
    window.addEventListener("resize", handleResize);

    // Cleanup listener
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getProductUrl = (product) => {
    const slug = product?.slug ? CreateSlug(product.slug) : CreateSlug(product?.title || "");
    return `/product/${slug}/${product._id}`;
  };

  const getSelectedProducts = (productIds = []) => {
    if (!Array.isArray(productIds)) {
      return [];
    }

    return Products.filter((product) => productIds.includes(product._id));
  };

  const renderPerfProductCard = (product) => (
    <div className="perf-card">
      <div className="perf-badges">
        {product?.isNew && <span className="perf-badge">New</span>}
        {product?.discountPercent && <span className="perf-badge">{product.discountPercent}%</span>}
      </div>

      <div className="perf-icons">
        <button className="perf-iconBtn" type="button" title="Wishlist">
          <i className="ri-heart-line"></i>
        </button>
        <button className="perf-iconBtn" type="button" title="Compare">
          <i className="ri-arrow-left-right-line"></i>
        </button>
        <Link to={getProductUrl(product)} className="perf-iconBtn" title="View">
          <i className="ri-eye-line"></i>
        </Link>
      </div>

      <Link to={getProductUrl(product)} className="perf-imageWrap">
        <img className="perf-image" src={product.pImage} alt={product.title} style={{ aspectRatio: '1/1' }} />
      </Link>

      <div className="perf-body">
        <div className="perf-brand">{product?.brand || product?.category || "Grand Bazzar"}</div>

        <div className="perf-titleRow">
          <Link to={getProductUrl(product)} className="perf-title text-truncate d-block">
            {product.title}
          </Link>
        </div>

        <div className="perf-rating" aria-label="Rating">
          <i className="ri-star-line"></i>
          <i className="ri-star-line"></i>
          <i className="ri-star-line"></i>
          <i className="ri-star-line"></i>
          <i className="ri-star-line"></i>
        </div>

        <div className="perf-bottomRow">
          <div className="perf-price">
            <span className="perf-priceNow">
              Rs. {product.salePrice || product.regularPrice}
            </span>

            {product.salePrice && product.regularPrice && (
              <del className="perf-priceOld">Rs. {product.regularPrice}</del>
            )}
          </div>

          <Link to={getProductUrl(product)} className="perf-cartBtn">
            View <i className="ri-arrow-right-up-line"></i>
          </Link>
        </div>
      </div>
    </div>
  );

  const renderProductSlider = (title, productIds) => {
    const selectedProducts = getSelectedProducts(productIds);

    if (!isProducts && selectedProducts.length === 0) {
      return null;
    }

    return (
      <div className="container pt-0 pt-sm-5">
        <div className="d-flex flex-wrap justify-content-between align-items-center pt-1 border-bottom pb-4 mb-4">
          <h2 className="h3 mb-0 me-2">{title}</h2>
        </div>

        <div className="row pt-2 mx-n2 hero-swiper hide-desk-arrow">
          <Swiper
            breakpoints={{
              300: { slidesPerView: 2, spaceBetween: 10 },
              768: { slidesPerView: 2, spaceBetween: 20 },
              992: { slidesPerView: 4, spaceBetween: 25 },
              1200: { slidesPerView: 4, spaceBetween: 20 },
            }}
            pagination={true}
            modules={[Pagination, Navigation]}
            className="swiper-wrapper p-0"
          >
            {isProducts ? (
              Array.from({ length: 7 }).map((_, index) => (
                <SwiperSlide key={index}>
                  <div className="card-1 skeleton" style={{ height: 371, borderRadius: 10 }}></div>
                </SwiperSlide>
              ))
            ) : (
              selectedProducts.map((product) => (
                <SwiperSlide key={product._id}>
                  {renderPerfProductCard(product)}
                </SwiperSlide>
              ))
            )}
          </Swiper>
        </div>
      </div>
    );
  };

  const renderBannerGrid = (banners, sectionClass = "pt-50 pb-50", columnClass = "col-md-4 p-0") => {
    if (!Array.isArray(banners) || banners.length === 0) {
      return null;
    }

    return (
      <div className={sectionClass}>
        <div className="container">
          <div className="row">
            {banners.map((banner, index) => (
              <Link className={columnClass} key={index} to={banner.imageUrlInput || "#"}>
                <img src={banner.imageInput} className="w-100" alt={`Home banner ${index + 1}`} />
              </Link>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const collectionLeft = {
    heading: layout.collection_left_heading || layout.collection_heading || "",
    paragraph: layout.collection_left_paragraph || layout.collection_paragraph || "",
    url: layout.collection_left_url || layout.collection_url || "#",
    buttonText: layout.collection_left_button_text || layout.collection_button_text || "Check More Products",
  };

  const collectionRight = {
    heading: layout.collection_right_heading || layout.collection_heading || "",
    paragraph: layout.collection_right_paragraph || layout.collection_paragraph || "",
    url: layout.collection_right_url || layout.collection_url || "#",
    buttonText: layout.collection_right_button_text || layout.collection_button_text || "Check More Products",
  };


  return (

    <>
      <Header />
{layout?.top_bar && 
<div className="bg-dark text-white"> <marquee> {layout.top_bar} </marquee>
</div>}
      <Helmet>
        {Headers && Headers.meta_favicon && (
          <link rel="apple-touch-icon" href={Headers.meta_favicon} />
        )}
        {Headers && Headers.meta_title && (
          <>
            <title>{Headers.meta_title}</title>
            {Headers.meta_description && (
              <meta name="description" content={Headers.meta_description} />
            )}
          </>
        )}
      </Helmet>

      <main className="page whitesmoke">
        {/* Hero Section */}
        <div className="hero hero-swiper"    style={{ width: 1897, maxWidth: '100% ', height: 'auto', aspectRatio:  `${isMobile ? '1/1':'1897/591'}`  }} >


          {isLoading ? (<>
            <div
              className="skeleton w-100"
              style={{ width: 1897, maxWidth: '100% ', height: 'auto', aspectRatio: `${isMobile ? '1/1':'1897/591'}` }}

            ></div>
          </>) : (

          <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>

{isMobile ? 
<>
  <Swiper pagination={true} navigation={true} gap={'30'}  ref={swiperRefLocal}
             autoplay={{
              delay: 1500,
              pauseOnMouseEnter: true,
          }}
          
          loop={true} modules={[Pagination, Navigation,Autoplay]} className="swiper-wrapper" >


              {Array.isArray(layout.home_slider) && layout.home_slider.length > 0 && (
                <>
                  {layout.home_slider.map((image, index) => (
                    <SwiperSlide key={index}> 
                      <img className="object-fit-cover w-100"
                        src={image}
                        alt={`Home slider ${index + 1}`}
                         style={{aspectRatio:'1/1'}}
                      />
                    </SwiperSlide>
                  ))}

                </>
              )}




            </Swiper>
</> : 
<>
  <Swiper pagination={true} navigation={true} gap={'30'}  ref={swiperRefLocal}
             autoplay={{
              delay: 1500,
              pauseOnMouseEnter: true,
          }}
          
          loop={true} modules={[Pagination, Navigation,Autoplay]} className="swiper-wrapper" >


              {Array.isArray(layout.home_slider) && layout.home_slider.length > 0 && (
                <>
                  {layout.home_slider.map((image, index) => (
                    <SwiperSlide key={index}> 
                      <img className="img-fluid w-100"
                        src={image}
                        alt={`Home slider ${index + 1}`}
                      />
                    </SwiperSlide>
                  ))}

                </>
              )}




            </Swiper>
</>}

          

            </div>

          )}


        </div>
        {/* Hero Section */}
 

          <section className="py-4 py-md-5 mb-50 mt-50">
      <div className="container">
        {/* Title */}
        <div className="row mb-3 mb-md-4">
          <div className="col-12">
            <h2 className="h2 mb-0 text-capitalize">Perfume by brands</h2>
          </div>
        </div>

        {/* Grid */}
        <div className="row g-3 g-md-4">
          {layout?.trending_product_carousal && layout?.trending_product_carousal.map((item, idx) => {
            const href = item?.imageUrlInput?.trim() ? item.imageUrlInput : "javascript:void(0)";
            return (
              <div className="col-6 col-sm-4 col-md-3 col-lg-2" key={idx}>
                <a
                  href={href}
                  className="d-flex align-items-center justify-content-center border rounded-3 bg-white p-2 text-decoration-none"
                >
                  <img
                    src={item.imageInput}
                    alt={`Brand logo ${idx + 1}`}
                    className="img-fluid"
                    style={{ height: "100px", objectFit: "contain" }}
                    loading="lazy"
                  />
                </a>
              </div>
            );
          })}
        </div>
      </div>
    </section>


        {renderBannerGrid(layout.trending_product_banner, "pt-50 pb-50", "col-md-4 p-0")}



 


 

<div className="pt-50 pb-50 "   >

 <div className="slider-text-box" style={{marginBottom:'-100px'}}>
    
    </div>        {/* Product Cards */}
        <div className="container pt-0 pt-sm-5">
          {/* Heading */}
          <motion.div  
             initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5, delay: 0.5 }}  >

  
          <div className="d-flex flex-wrap justify-content-center align-items-center pt-1   pb-0 mb-0">
           
            <div className="ms-n4">
              {/* <a
                className="btn btn-sm btn-link link-info link-hover-primary d-flex align-items-center bg-btn-new"
                href="#"
              >
                View All
                <i className="ri-arrow-right-line ms-1" />
              </a> */}
            </div>
          </div>
       
                  </motion.div>

          {/* Heading */}
          {/* Product Cards */}
          <div className="row pt-2 mx-n2 hero-swiper hide-desk-arrow">
            {/* Product Card */}
            <Swiper breakpoints={{
              300: {
                slidesPerView: 2,
                spaceBetween: 10, // Set the gap between slides for window width <= 400px
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20, // Set the gap between slides for window width <= 768px
              },
              992: {
                slidesPerView: 4,
                spaceBetween: 25, // Set the gap between slides for window width <= 992px
              },
              1200: {
                slidesPerView: 4,
                spaceBetween: 20, // Set the gap between slides for window width <= 1200px
              },
            }}
              pagination={true} modules={[Pagination, Navigation]} className="swiper-wrapper p-0" >



              {isProducts ? (Array.from({ length: 7 }).map((_, index) => (
                <SwiperSlide key={index} >
                  <div
                    className="card-1 skeleton"
                    style={{ height: 371, borderRadius: 10 }}
                  ></div>

                </SwiperSlide>
              ))
              ) : (layout.trending_product && (
                <>
                  {Products
  .filter(product => layout.trending_product.includes(product._id))
  .map((product, index) => (
                      
                      layout.trending_product.includes(product._id) && (<>

                        <SwiperSlide key={index}>

                        <div className={`perf-card `}>
  {/* Badges */}
  <div className="perf-badges">
    {/* Example: show NEW */}
    {product?.isNew && <span className="perf-badge">New</span>}
    {/* Example: show discount */}
    {product?.discountPercent && <span className="perf-badge">{product.discountPercent}%</span>}
  </div>

  {/* Right icon buttons */}
  <div className="perf-icons">
    <button className="perf-iconBtn" type="button" title="Wishlist">
      <i className="ri-heart-line"></i>
    </button>
    <button className="perf-iconBtn" type="button" title="Compare">
      <i className="ri-arrow-left-right-line"></i>
    </button>
    <Link to={`/product/${product.slug}/${product._id}`} className="perf-iconBtn" title="View">
      <i className="ri-eye-line"></i>
    </Link>
  </div>

  {/* Image */}
  <Link to={`/product/${product.slug}/${product._id}`} className="perf-imageWrap">
    <img className="perf-image" src={product.pImage} alt={product.title} style={{aspectRatio:'1/1'}} />
  </Link>

  {/* Content */}
  <div className="perf-body">
    <div className="perf-brand">{product?.brand || "Rihanna"}</div>

    <div className="perf-titleRow">
      <Link to={`/product/${product.slug}/${product._id}`} className="perf-title text-truncate d-block">
        {product.title}
      </Link>
    </div>

    {/* Weight row */}
    <div className="perf-weightRow d-none">
      <div className="perf-weightLabel">Weight:</div>

      <select className="perf-weightSelect">
        {/* You can map actual weights/variants here */}
        <option>60ml</option>
        <option>75ml</option>
        <option>80ml</option>
      </select>
    </div>

    {/* Rating */}
    <div className="perf-rating" aria-label="Rating">
      <i className="ri-star-line"></i>
      <i className="ri-star-line"></i>
      <i className="ri-star-line"></i>
      <i className="ri-star-line"></i>
      <i className="ri-star-line"></i>
    </div>

    {/* Price + Add to cart */}
    <div className="perf-bottomRow">
      <div className="perf-price">
        <span className="perf-priceNow">
          Rs. {product.salePrice || product.regularPrice}
        </span>

        {product.salePrice && product.regularPrice && (
          <del className="perf-priceOld">Rs. {product.regularPrice}</del>
        )}
      </div>

      <button className="perf-cartBtn" type="button">
        Add to Cart <i className="ri-shopping-bag-3-line"></i>
      </button>
    </div>
  </div>
</div>
                          {/* Product Cards */}

                        </SwiperSlide>

                      </>)


                    ))} 
 
                </>
              )
              )}




            </Swiper >

          </div>
          {/* Product Cards */}
        </div>
        {/* Product Cards */}
</div>


 
 {layout?.collection_img && (
 <section className="pt-50">
  <div className="container">
<div className="row">
    {/* LEFT */}
    <div className="col-md-4">
      <h2 className="spray-title">
        <span className="bold">{collectionLeft.heading}</span><br />
      </h2>

      <p className="spray-text">
        {collectionLeft.paragraph}
      </p>

      <Link className="spray-btn" to={collectionLeft.url}>
        {collectionLeft.buttonText} <i className="ri-shopping-bag-3-line"></i>
      </Link>
    </div>

    {/* CENTER IMAGE */}
    <div className="col-md-4">
      <img
          className="w-100 pt-50 pb-50"
          src={layout.collection_img}
          alt={layout.collection_heading || collectionLeft.heading || collectionRight.heading || "Collection"}
        />
    </div>

    {/* RIGHT */}
    <div className="col-md-4 text-md-end pt-4 pb-4">
      <h2 className="spray-title">
        <span className="bold">{collectionRight.heading}</span><br />
      </h2>

      <p className="spray-text">
        {collectionRight.paragraph}
      </p>

      <Link className="spray-btn" to={collectionRight.url}>
        {collectionRight.buttonText} <i className="ri-shopping-bag-3-line"></i>
      </Link>
    </div>
  </div>

  </div>
  
</section>
 )}



        <div className=" pt-0 pt-sm-5 d-none">

          <div className=" py-0">

            {isLoading ? (<>
              <div
                className="skeleton "
                style={{ height: 380, borderRadius: 10 }}
              ></div>  <div
                className=" skeleton "
                style={{ height: 380, borderRadius: 10 }}
              ></div>
            </>) : (layout?.trending_product_banner && layout?.trending_product_banner && (
              <>

                {layout?.trending_product_banner && layout?.trending_product_banner.map((banner, index) => (

                  <Link class="w-100" key={index} to={banner.imageUrlInput} >
                    <img src={banner.imageInput} className="w-100 rounded" />
                  </Link>
                ))}
              </>
            )
            )}

          </div>
</div>


        <div className="container  pt-50 pb-50 d-none "> 
          <div className="row mt-4 pt-2 mx-n2 hero-swiper ">
            <Swiper breakpoints={{
              300: {
                slidesPerView: 2,
                spaceBetween: 10, // Set the gap between slides for window width <= 400px
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20, // Set the gap between slides for window width <= 768px
              },
              992: {
                slidesPerView: 4,
                spaceBetween: 25, // Set the gap between slides for window width <= 992px
              },
              1200: {
                slidesPerView: 4,
                spaceBetween: 25, // Set the gap between slides for window width <= 1200px
              },
            }}
              navigation={false} pagination={true} modules={[Pagination, Navigation]} className="swiper-wrapper" >


              {isLoading ? (Array.from({ length: 7 }).map((_, index) => (
                <SwiperSlide key={index} >
                  <div
                    className="card-1 skeleton"
                    style={{ height: 355, borderRadius: 10 }}
                  ></div>

                </SwiperSlide>
              ))
              ) : (layout.trending_product_carousal && (
                <>

                  {layout.trending_product_carousal.map((carousal, index) => (

                    <SwiperSlide key={index}>
                      <Link to={carousal.imageUrlInput}  >
                        <motion.img     initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    transition={{ duration: 0.5, delay:  0.2 + Number('0.'+index) }}
     src={carousal.imageInput} className="w-100 rounded" />
                      </Link>

                    </SwiperSlide>

                  ))}
                </>
              )
              )}



            </Swiper>

          </div>

        </div>

<br/>

 
 
<div    className="mt-0 startbg d-none"> 
        {/* Banner */}
        <div className="container py-4 py-lg-0">
          <div className="row ">

            {isLoading ? (<>
              <div
                className="col skeleton "
                style={{ height: 380, borderRadius: 10 }}
              ></div>
            </>) : (layout.latest_product_banner && (
              <>

                <div className="col ">
                  <div
                    className="row justify-content-between align-items-center overflow-hidden border rounded-1 customborder py-4 my-4"
                   
                  >
                    <div className="col-md-6">

                   <div className="py-4 my-4 my-md-0   px-4 ms-md-3 text-center text-sm-start ">
                      {/* <h6 className="fs-xs text-accent text-uppercase mb-2">
                        Weekend Discount
                      </h6> */}
                      <h2 className="fw-medium mb-4 h1">{layout.collection_heading || ''}</h2>
                      <p className=" text-dark">
                        {layout.collection_paragraph || ''}  


                      </p>
                      {/* <Link className="btn btn-shadow" style={{backgroundColor:'#333333',color:'#FFE1E1'}} to={layout.collection_url || ''}>
                        Shop Now
                      </Link> */}

                      <div className="mt-4 pt-4">
                        <button class="custom-button "> <Link to={layout.collection_url || ''} > Shop Now </Link> <div class="button__horizontal"></div><div class="button__vertical"></div></button>
                      </div>
                    </div>

                    </div>
                   
                    <div className="col-md-5 ms-auto">
                     <img
                      className="w-100 my-4"
                      src={layout.collection_img || ''}
                      alt="Shop Converse"
                      width={'100%'} 
                      style={{transform:'scale(1.1) rotatey(180deg) translateX(-40px)'}}
                    />
                    </div>
                   
                  </div>
                </div>
              </>
            )
            )}



          </div>
        </div>
        {/* Banner */}
</div>



        {/* Product Cards */}
        <div className="container pt-0 pt-sm-5 ">
          {/* Heading */}
          <div className="d-flex flex-wrap justify-content-between align-items-center pt-1 border-bottom pb-4 mb-4">
            <h2 className="h3 mb-0 me-2">Trending products</h2>
            <div className="ms-n4">
              {/* <a
                className="btn btn-sm btn-link link-info link-hover-primary d-flex align-items-center bg-btn-new"
                href="#"
              >
                View All
                <i className="ri-arrow-right-line ms-1" />
              </a> */}
            </div>
          </div>
          {/* Heading */}
          {/* Product Cards */}

 
       {/* Product Cards */}
          <div className="row pt-2 mx-n2 hero-swiper hide-desk-arrow">
            {/* Product Card */}
            <Swiper breakpoints={{
              300: {
                slidesPerView: 2,
                spaceBetween: 10, // Set the gap between slides for window width <= 400px
              },
              768: {
                slidesPerView: 2,
                spaceBetween: 20, // Set the gap between slides for window width <= 768px
              },
              992: {
                slidesPerView: 4,
                spaceBetween: 25, // Set the gap between slides for window width <= 992px
              },
              1200: {
                slidesPerView: 4,
                spaceBetween: 20, // Set the gap between slides for window width <= 1200px
              },
            }}
              pagination={true} modules={[Pagination, Navigation]} className="swiper-wrapper p-0" >



              {isProducts ? (Array.from({ length: 7 }).map((_, index) => (
                <SwiperSlide key={index} >
                  <div
                    className="card-1 skeleton"
                    style={{ height: 371, borderRadius: 10 }}
                  ></div>

                </SwiperSlide>
              ))
              ) : (layout.trending_product && (
                <>
                  {Products
  .filter(product => layout.trending_product.includes(product._id))
  .map((product, index) => (
                      
                      layout.trending_product.includes(product._id) && (<>

                        <SwiperSlide key={index}>

                        <div className={`perf-card `}>
  {/* Badges */}
  <div className="perf-badges">
    {/* Example: show NEW */}
    {product?.isNew && <span className="perf-badge">New</span>}
    {/* Example: show discount */}
    {product?.discountPercent && <span className="perf-badge">{product.discountPercent}%</span>}
  </div>

  {/* Right icon buttons */}
  <div className="perf-icons">
    <button className="perf-iconBtn" type="button" title="Wishlist">
      <i className="ri-heart-line"></i>
    </button>
    <button className="perf-iconBtn" type="button" title="Compare">
      <i className="ri-arrow-left-right-line"></i>
    </button>
    <Link to={`/product/${product.slug}/${product._id}`} className="perf-iconBtn" title="View">
      <i className="ri-eye-line"></i>
    </Link>
  </div>

  {/* Image */}
  <Link to={`/product/${product.slug}/${product._id}`} className="perf-imageWrap">
    <img className="perf-image" src={product.pImage} alt={product.title} style={{aspectRatio:'1/1'}} />
  </Link>

  {/* Content */}
  <div className="perf-body">
    <div className="perf-brand">{product?.brand || "Rihanna"}</div>

    <div className="perf-titleRow">
      <Link to={`/product/${product.slug}/${product._id}`} className="perf-title text-truncate d-block">
        {product.title}
      </Link>
    </div>

    {/* Weight row */}
    <div className="perf-weightRow d-none">
      <div className="perf-weightLabel">Weight:</div>

      <select className="perf-weightSelect">
        {/* You can map actual weights/variants here */}
        <option>60ml</option>
        <option>75ml</option>
        <option>80ml</option>
      </select>
    </div>

    {/* Rating */}
    <div className="perf-rating" aria-label="Rating">
      <i className="ri-star-line"></i>
      <i className="ri-star-line"></i>
      <i className="ri-star-line"></i>
      <i className="ri-star-line"></i>
      <i className="ri-star-line"></i>
    </div>

    {/* Price + Add to cart */}
    <div className="perf-bottomRow">
      <div className="perf-price">
        <span className="perf-priceNow">
          Rs. {product.salePrice || product.regularPrice}
        </span>

        {product.salePrice && product.regularPrice && (
          <del className="perf-priceOld">Rs. {product.regularPrice}</del>
        )}
      </div>

      <button className="perf-cartBtn" type="button">
        Add to Cart <i className="ri-shopping-bag-3-line"></i>
      </button>
    </div>
  </div>
</div>
                          {/* Product Cards */}

                        </SwiperSlide>

                      </>)


                    ))} 
 
                </>
              )
              )}




            </Swiper >

          </div>
          {/* Product Cards */}


          {/* Product Cards */}
        </div>
        {/* Product Cards */}
 

 
<br/>

{renderProductSlider("Latest products", layout.latest_product)}

<br/>

{renderProductSlider("Best selling", layout.best_selling_laptop)}

<br/>

 
 
{renderBannerGrid(layout.latest_product_banner, "pt-50 pb-50", "col-md-4 p-0")}




       
<div className="d-none b-50 mb-50">
  <div className="container">
  
   {layout?.trending_product_banner && layout?.trending_product_banner.map((banner, index) => (

                  <Link class="w-100 mb-4 pb-3" key={index} to={banner.imageUrlInput} >
                    <img src={banner.imageInput} className="w-100 rounded" />
                  </Link>
                ))}
                  
  </div>
</div>


<br/>
{renderProductSlider("Most Popular Product", layout.best_selling_smartphone)}

<br/>



        {/* Product Widgets */}
<div className="bg-white pt-50 b-50 border-top">

<div className="container " >
  <h2 className="text-uppercase mb-50 text-center"> our latest blogs </h2>
 
 <div className="row col-md-11 mx-auto">
  {blogs.map((blog) => (
    <div className="col-md-4 mb-3" key={blog._id}>
     
      <Link to={`/blog/${blog._id}`} className="abutton"> <img
        src={blog.image}
        alt={blog.title}
        className="w-100"
        style={{aspectRatio:'1/1',objectFit:'cover'}}
      />

      <h4 className="mt-3">{blog.title}</h4>  </Link>

      <Link to={`/blog/${blog._id}`} className="abutton">
        READ MORE
      </Link>
    </div>
  ))}
</div>


</div>
<div className="text-center mt-50 ">
  <button className="perf-cartBtn" type="button">  All Blogs <i className="ri-arrow-right-up-line"/> </button>
  {/* <button class="custom-button mx-auto"  > <Link to="/allblogs"> All Blogs</Link><div class="button__horizontal"></div><div class="button__vertical"></div></button> */}
</div>
 
</div>




<section className="mt-50 mb-50">
<div className="container">
  <div className="border bg-white" style={{border:'2px solid black'}}>
<iframe
  scrolling="no"
  aria-label="Instagram"
  className="w-100"
  height={'443'}
  src="https://www.instagram.com/grandbazar_official/embed"
/>

  </div>

</div>
</section>




       </main>


      <Footer />

    </>
  )
}

export default HomeNew
